import styled from 'styled-components';
import { theme } from '../../global';

export const PreviewTourContainer = styled.div`
  display: flex;
  gap: ${theme.spacings.s16};
  flex-direction: column;
`;

export const Line = styled.hr`
  border-top: 1px solid ${theme.colors.line};
`;

export const Title = styled.h3`
  font-family: 'Montserrat';
  font-weight: 600;
  font-size: 20px;
  line-height: 24.38px;
  color: ${theme.colors.primaryText};

  &:hover {
    text-decoration: underline;
    text-decoration-style: solid;
  }
`;
